// Título/descrição padrão da área pública — usado pela Home e como
// fallback por páginas que ainda não têm um título/descrição específico
// pronto (ex: EventDetailPage enquanto carrega, evento não encontrado).
export const DEFAULT_SEO_TITLE = 'Joyn — Descubra eventos em Joinville';
export const DEFAULT_SEO_DESCRIPTION = 'Shows, festivais, teatro, esportes e muito mais. Descubra os melhores eventos de Joinville em um só lugar.';
